module.exports = __webpack_public_path__ + "static/media/inboundSwap.00c70d10.svg";